import { Invoice } from '../models/invoice';

export const calculateInvoiceTotal = (invoice: Invoice): number => {
  if (invoice.hourlyRate && invoice.totalHours) {
    if (invoice.expenses) {
      return (
        Number(invoice.expenses) +
        Number(invoice.hourlyRate) * Number(invoice.totalHours)
      );
    } else {
      return Number(invoice.hourlyRate) * Number(invoice.totalHours);
    }
  } else {
    if (invoice.expenses) {
      return Number(invoice.total) + Number(invoice.expenses);
    } else {
      return Number(invoice.total);
    }
  }
};

export default calculateInvoiceTotal;
